import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { DateDrillDownComponent } from "@components/date-drill-down/date-drill-down.component";
import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { IDateDrillDownSelectedItem } from "~app/common/components/date-drill-down/components/date-drill-down-selector/models/dateDrillDownSelectedItem";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { AggregatPeriods } from "~app/common/models/aggregatperiod";
import { LeveransraderCreateComponent } from "../../leveransrader-create/leveransrader-create.component";
import { ILeverantorsorderDetail, ILeverantorsorderDetailRad } from "../../models/leverantorsorder-detail-model";
import { LeveransraderHotService } from "./leveransrader-hot.service";
import { LeverantorsorderradAggregat } from "./leverantorsorderradAggregat";

@Component({
    selector: "rask-leverantorsorder-leveransrader",
    templateUrl: "./leverantorsorder-leveransrader.component.html",
    styleUrls: ["./leverantorsorder-leveransrader.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        ActionButtonComponent,
        FormsModule,
        DateDrillDownComponent,
        HotDocComponent,
        TranslatePipe
    ]
})

export class LeverantorsorderLeveransraderComponent implements OnInit {
    @Input() canEdit: boolean;
    hotDoc: HotDoc;
    model: LeverantorsorderradAggregat;
    @Input() order: ILeverantorsorderDetail;
    @Input() orderrad: ILeverantorsorderDetailRad;

    private readonly leveransraderHotService = inject(LeveransraderHotService);
    private readonly modalService = inject(NgbModal);

    addForsorjningskalla = () => {
        const modalRef = this.modalService.open(LeveransraderCreateComponent, {
            keyboard: false,
            centered: true,
            backdrop: "static",
            size: "lg"
        });
        modalRef.componentInstance.leverantorsorderrad = this.model;
        modalRef.result.then(r => {
            if (r) {
                this.hotDoc.rebind();
            }
        });
    };

    ngOnInit(): void {
        this.model = new LeverantorsorderradAggregat(this.orderrad);
        this.hotDoc = this.leveransraderHotService.createHotDoc(this.model, !this.canEdit);
    }

    onDateSelected(item: IDateDrillDownSelectedItem) {
        const selectedPeriod = {
            type: item.periodType,
            from: item.periodStart,
            to: item.periodEnd,
            periodMonth: item.periodMonth
        };

        this.model.period = AggregatPeriods.create("sv-SE", selectedPeriod);
        this.hotDoc.rebind();
    }
}
